<ng-template #content>
    <div class="d-flex" [class.gap-1]="compact()" [class.gap-2]="!compact()">
        @if (isLoading) {
            <fdx-spinner size="sm"></fdx-spinner>
        } @else if (iconOverrideContent) {
            <ng-container *ngTemplateOutlet="iconOverrideContent"></ng-container>
        } @else if (iconOverride !== null && (iconOverride || themeType.icon)) {
            <fa-icon [icon]="iconOverride || themeType.icon" [ngClass]="iconClasses"></fa-icon>
        }

        <div class="d-flex flex-column gap-2">
            <div class="text-start">
                @if (title) {
                    <span class="alert-title"
                        [innerHTML]="title | prettyHtml">
                    </span>
                }

                @if (title && separateTitle) {
                    <br/>
                }

                @if (body) {
                    <span
                        class="ms-1"
                        [ngClass]="bodyClasses"
                        [innerHTML]="body | prettyHtml"
                        fdxStopPropagation
                        [stopPropogationBypass]="clickable">
                    </span>
                } @else {
                    <span fdxStopPropagation [stopPropogationBypass]="clickable"><ng-content></ng-content></span>
                }

            </div>

            @if (extraContent) {
                <div fdxStopPropagation [stopPropogationBypass]="clickable">
                    <ng-container *ngTemplateOutlet="extraContent"></ng-container>
                </div>
            }

        </div>
    </div>
</ng-template>

<ngb-alert [type]="theme" [ngClass]="alertClasses" [dismissible]="dismissible" (closed)="close()">
    <button *ngIf="clickable; else notClickable" type="button" class="unstyled-button w-100" (click)="alertClicked()">
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </button>
    <ng-template #notClickable>
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </ng-template>
</ngb-alert>
